import React, { useState, useEffect, useMemo } from "react";
import { Button, useTheme, Box, IconButton, Stack, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, Typography, Checkbox } from "@mui/material";
import { tokens } from "../../../assets/theme";
import { useQuery } from "@tanstack/react-query";
//import { useLocalStorage } from "../../../hooks/useLocalStorage";
//Components
import AxionControls from "../../../components/controls/AxionControls";
import { pushErrorMessage } from "../../../utils/notifications";
//import AxionConfirmation from '../../../components/controls/AxionConfirmation';
//import Controls from "../../../components/controls/Contols";

//Hooks
import { getBlockers, postBlocker, updateBlocker, deleteBlocker } from "../../../fetchers/productionPlan";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
//Icons
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
//Language
//import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import { event } from "jquery";
import { set } from "date-fns";
import { CheckBoxOutlineBlank } from "@mui/icons-material";

export default function ProductionPlanEditBlockers(props) {

    const { formatMessage } = useIntl();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [showDialog, setShowDialog] = useState(false);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);

    const [newBlocker, setNewBlocker] = useState({ id: null, companyKey: companyKey, description: "", color: randomHexColor(), static: true });

    const newcolor = "#" + Math.floor(Math.random() * 0xFFFFFF).toString(16).padStart(6, "0");

    function randomHexColor() {
        return "#" + Math.floor(Math.random() * 16777215)
            .toString(16)
            .padStart(6, "0");
    }

    const blockerQuery = useQuery(
        ["blocker"],
        () => getBlockers(),
        {}
    );

    const handleDescriptionChange = (event) => {
        let blocker = { ...newBlocker };
        blocker.description = event.target.value;
        setNewBlocker(blocker);
    }

    const handleColorChange = (color, colors) => {
        let blocker = { ...newBlocker };
        blocker.color = colors.hex;
        setNewBlocker(blocker);
    }
    const handleStaticChange = (event) => {
        let blocker = { ...newBlocker };
        //console.log("Static event.target.checked", event.target.checked);
        blocker.static = event.target.checked;
        setNewBlocker(blocker);
    }


    const handleShowAddDialog = () => {
        setShowDialog(true);
    }

    const handleEditBlockerClick = (blockerId) => {
        let blocker = blockerQuery?.data?.find((b) => b.id === blockerId);
        if (blocker) {
            setNewBlocker({ ...blocker });
            setShowDialog(true);
        }
    }

    const handleAddBlocker = () => {

        //Validate inputs
        if (newBlocker.description.trim() === "") {
            pushErrorMessage("Please enter a description for the blocker.");
            return;
        }
        if (newBlocker.color.trim() === "") {
            pushErrorMessage("Please select a color for the blocker.");
            return;
        }
        props.setShowBackdrop(true);

        if (newBlocker.id !== null) {
            // Update existing blocker
            updateBlocker(newBlocker).then((result) => {

                if (result.status) {
                    setNewBlocker({ id: null, companyKey: companyKey, description: "", color: randomHexColor(), static: true });
                    //pushNotification("Block created!");
                    console.log("Blocker updated:", result);
                    setShowDialog(false);



                    props.setShowBackdrop(false);
                    //setButtonDisabled(false);
                    props.setOpenAddPopup(false);


                } else {
                    console.log("Blocker NOT updated", result);
                    pushErrorMessage("Block not created: " + result?.message);
                }
            }
            ).catch((error) => {
                console.log("Could not update blocker", error);
                props.setShowBackdrop(false);
                pushErrorMessage("Block not created: " + error?.message);
            });

        } else {


            postBlocker(newBlocker).then((result) => {

                console.log("Blocker created:", result);

                props.setShowBackdrop(false);
                //setButtonDisabled(false);
                //props.setOpenAddPopup(false);

                if (result.status) {
                    setNewBlocker({ id: null, companyKey: companyKey, description: "", color: randomHexColor(), static: true });
                    //pushNotification("Block created!");
                    console.log("Blocker created");
                    setShowDialog(false);
                } else {
                    console.log("Blocker NOT created", result);
                    pushErrorMessage("Block not created: " + result?.message);
                }
            }).catch((error) => {
                console.log("Could not create blocker", error);
                pushErrorMessage("Could not create blocker: " + error?.message);
                props.setShowBackdrop(false);
                //setButtonDisabled(false);
            });
        }
    }

    const handleDeleteBlocker = (blockerId) => {
        
        console.log ("Deleting blocker", blockerId);

        deleteBlocker(blockerId).then((result) => {

                console.log("Blocker deleted:", result);

                props.setShowBackdrop(false);
                //setButtonDisabled(false);
                //props.setOpenAddPopup(false);

                if (result.status) {
                    setNewBlocker({ id: null, companyKey: companyKey, description: "", color: randomHexColor(), static: true });
                    //pushNotification("Block created!");
                    console.log("Blocker deleted");
                    setShowDialog(false);
                } else {
                    console.log("Blocker NOT deleted", result);
                    pushErrorMessage("Block not deleted: " + result?.message);
                }
            }).catch((error) => {
                console.log("Could not delete blocker", error);
                pushErrorMessage("Could not delete blocker: " + error?.message);
                props.setShowBackdrop(false);
                //setButtonDisabled(false);
            });

    }

    const handleCloseBlockerDialog = () => {
        //setNewBlocker({ id: null, companyKey: props.companyKey, description: "", color: randomHexColor(), static: false });
        setShowDialog(false);
    };

    if (blockerQuery === undefined || blockerQuery.data === undefined || blockerQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }

    return (
        <>
            {/* <Box padding="30px"> </Box> */}
            <Box width="95%">
                <Box width="100%" justifyContent="flex-start" alignItems="center" display="flex" marginTop="10px" marginBottom="20px" marginLeft="15px">

                    <Button
                        onClick={handleShowAddDialog}
                        text="Add blocker" //{formatMessage(messages.add_department)}
                        startIcon={<AddCircleOutlinedIcon />}
                        sx={{
                            "&:hover": {
                                backgroundColor: colors.dashbordGreen[700],
                            },
                            backgroundColor: colors.dashbordGreen[500],
                            color: "#000000",
                        }}
                    >Add blocker</Button>
                </Box>
                <Stack direction="column" width="100%" overflow="hidden" backgroundColor={colors.primary[300]} marginTop="5px" color="#ffffff" spacing="1px" marginLeft="15px">
                    {blockerQuery?.data?.sort((a, b) => (a.description > b.description) ? 1 : -1).map((a) => {
                        return (
                            <>
                                <Stack direction="row" width="100%" backgroundColor={colors.primary[500]}>

                                    <Box width="30%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" onClick={() => handleEditBlockerClick(a.id)}>{a.description}</Box>
                                    <Box width="30%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" onClick={() => handleEditBlockerClick(a.id)}>
                                        <Box sx={{ width: "15px", height: "15px", backgroundColor: a.color, borderRadius: "2px", marginRight: "7px" }} ></Box> 
                                        {a.color}
                                    </Box>
                                    <Box width="20%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" onClick={() => handleEditBlockerClick(a.id)}>

                                        {a.static ? "Static" : "Not static"}
                                    </Box>
                                    <Box width="30%" justifyContent="flex-end" alignItems="center" display="flex">

                                        <Tooltip title={<Typography fontSize="12px">Edit blocker {a.description}</Typography>}>
                                            <IconButton onClick={() => { handleEditBlockerClick(a.id) }}><EditOutlinedIcon /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={<Typography fontSize="12px">Delete blocker {a.description}</Typography>}>
                                            <span>
                                                <IconButton onClick={() => { handleDeleteBlocker(a.id) }}><DeleteOutlinedIcon /></IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Stack>
                            </>
                        )
                    })}
                    <Box padding="0px"> </Box>
                </Stack>
            </Box>

            <Dialog open={showDialog} onClose={handleCloseBlockerDialog} m={0} width="400px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="400px" >
                    {/* <form onSubmit={handleAddDimension}> */}
                    <DialogTitle>{(newBlocker.id === null) ? "Add a new blocker" : "Update a blocker"}</DialogTitle>
                    <DialogContent>

                        <Stack direction="column" width="100%" overflow="hidden" >
                            <Box><AxionControls.AxionTextBox
                                label="Description" //{<FormattedMessage {...messages.timezone} />}
                                value={newBlocker.description}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleDescriptionChange(event)
                                }
                            /></Box>
                            <Box sx={{ marginTop: 2 }}>
                                <AxionControls.AxionColorPicker
                                    name="colorCode"
                                    label={"Pick a color"}
                                    value={newBlocker.color}
                                    onChange={handleColorChange}
                                    sx={{ width: 400 }}
                                />
                            </Box>
                            <Stack direction="row" spacing={1} display="flex" alignItems="center" sx={{ marginTop: 2, marginLeft: 0 }} >
                                <Checkbox
                                    label="Static blocker"
                                    onChange={handleStaticChange}
                                    checked={newBlocker.static}
                                    sx={{marginLeft: 0,
                                        color: "#ffffff",
                                        '&.Mui-checked': {
                                            color: "#ffffff",
                                        },
                                    }}

                                />
                                <Box>Static</Box>
                            </Stack>
                        </Stack>
                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Button
                                text="Close"
                                onClick={handleCloseBlockerDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            >Close</Button>
                            <Button
                                marginLeft="10px"
                                text={(newBlocker.id === null) ? "Add blocker" : "Update blocker"}
                                onClick={handleAddBlocker}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            >{(newBlocker.id === null) ? "Add blocker" : "Update blocker"}</Button>
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>
        </>
    );
}





